module.exports = __webpack_public_path__ + "static/media/bar.30e9e702.svg";